import cloneDeep from 'lodash/cloneDeep';
import { createSelector } from 'reselect';
import { detailedModelPortfoliosSelector } from '../AssetAllocations/AssetAllocationSelector';
import DetailedAssetAllocationChartDescriptor from './DetailedAssetAllocationChartDescriptor';

export const detailedModelPortfolioSelector = createSelector(
  detailedModelPortfoliosSelector,
  (_, ownProps) => ownProps,
  (detailedModelPortfolios, ownProps) => {
    const { name, id } = ownProps;
    const modelPortfolio = detailedModelPortfolios.find(portfolio => portfolio.Id === id);

    if (
      detailedModelPortfolios.length > 0 &&
      modelPortfolio && modelPortfolio.length === 0 &&
      name
    ) {
      return detailedModelPortfolios[0];
    }
    return modelPortfolio;
  },
);

function mouseOver() {
  const element = document.querySelector(`[data-daa-id="${this.name}"`);
  if (element) {
    element.classList.add('highlighted');
  }
}

function mouseOut() {
  const element = document.querySelector(`[data-daa-id="${this.name}"`);
  if (element) {
    element.classList.remove('highlighted');
  }
}

export const chartDataSelectorFunction = (modelPortfolio) => {
  const { ADV } = window;
  const hcParams = cloneDeep(DetailedAssetAllocationChartDescriptor);

  if (modelPortfolio) {
    const AllocationData = ADV.util.chart.parseAllocationSeries(modelPortfolio.AssetClassChart);
    hcParams.series[0].data = AllocationData.Series;
    hcParams.series[0].animation = true;
  }
  hcParams.plotOptions.pie.point.events.mouseOver = mouseOver;
  hcParams.plotOptions.pie.point.events.mouseOut = mouseOut;
  hcParams.plotOptions.series.states.hover.enabled = true;
  return hcParams;
};

export const legendSelectorFunction = (detailedModelPortfolio) => {
  const { ADV } = window;
  if (detailedModelPortfolio) {
    return ADV.util.chart.parseAllocationSeries(detailedModelPortfolio.AssetClassChart).Labels;
  }
  return [];
};

export const chartDataSelector = createSelector(
  detailedModelPortfolioSelector,
  chartDataSelectorFunction,
);

export const legendSelector = createSelector(
  detailedModelPortfolioSelector,
  legendSelectorFunction,
);
